import React, {useEffect, useState} from 'react';
import {LabelText} from '../../Language/LabelText';
import './IECompatibilityMessage.css'

const IECompatibilityMessage = () => {
    const [showMessage, setShowMessage]=useState(false);

    useEffect(() => {
        const ua = window.navigator.userAgent;
        const isIE= ua && (ua.includes('MSIE ') || ua.includes('Trident/'));
        setShowMessage(isIE);
    }, []);    

    return (showMessage ? <div class="ie-compatability-msg">
                <p><LabelText tid="IECompatabilityMessage" /></p>
            </div> : null);
}

export default IECompatibilityMessage;

